module.exports = __webpack_public_path__ + "static/media/controlerPanel.6a972ad6.png";